import React, { useCallback } from 'react';
import { BaseMultiPageModel, BorderAlignmentTypes, type TextElement } from '@bynder-studio/render-core';
import BorderWeightAlignment from '../../BorderWeightAlignment';

type Props = {
    isDisabled: boolean;
    selectedElement: TextElement;
    creativeModel: BaseMultiPageModel;
};

const TextBackgroundBorderWeight = ({ isDisabled, selectedElement, creativeModel }: Props) => {
    const id = selectedElement.id;
    const textBackground = selectedElement.textBackground;

    const handleBorderWidthChange = useCallback(
        (borderWidth: number) => {
            creativeModel.updateElement(id, {
                textBackground: {
                    ...textBackground,
                    borderWidth,
                },
            });
        },
        [creativeModel, textBackground, id],
    );

    const handleBorderAlignmentChange = useCallback(
        (borderAlignment: BorderAlignmentTypes) => {
            creativeModel.updateElement(id, {
                textBackground: {
                    ...textBackground,
                    borderAlignment,
                },
            });
        },
        [creativeModel, textBackground, id],
    );

    return (
        <BorderWeightAlignment
            isDisabled={selectedElement.locked || isDisabled}
            defaultBorderWidth={selectedElement.textBackground.borderWidth}
            defaultBorderAlignment={selectedElement.textBackground.borderAlignment}
            onBorderWidthChange={handleBorderWidthChange}
            onBorderAlignmentChange={handleBorderAlignmentChange}
        />
    );
};

export default TextBackgroundBorderWeight;
